export enum EdgeTypes {
  Custom = "custom",
  Floating = "floating"
}
